import React, { useRef, useState } from 'react';
import SectionHeader from './SectionHeader';
import Field from './Field';
import LayoutCard from './LayoutCard';
import PhotoCard from './PhotoCard';
import { uploadReportImage } from '../../../services/saleReport/saleReportService';
import legacy from '../../../utils/legacy';
import styles from '../SaleReportPage.module.scss';

const ImageIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <circle cx="8.5" cy="10" r="1.5" />
    <path d="M3 17l5-5 4 4 3-3 6 6" />
  </svg>
);

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

const LAYOUTS = [
  {
    key: 'A',
    label: 'A. 1장',
    minPhotos: 1,
    gridStyle: { gridTemplateColumns: '1fr' },
    cells: [{ hero: true }],
  },
  {
    key: 'B',
    label: 'B. 3장',
    minPhotos: 3,
    gridStyle: { gridTemplateColumns: '1.7fr 1fr', gridTemplateRows: '1fr 1fr' },
    cells: [
      { hero: true, style: { gridRow: '1 / span 2' } },
      {},
      {},
    ],
  },
  {
    key: 'D',
    label: 'D. 6장',
    minPhotos: 6,
    gridStyle: { gridTemplateColumns: 'repeat(3,1fr)', gridTemplateRows: '1fr 1fr' },
    cells: [
      { hero: true }, {}, {},
      {}, {}, {},
    ],
  },
];

// photo 객체 또는 문자열 → thumb URL
function getThumb(photo) {
  if (!photo) return '';
  if (typeof photo === 'string') return photo;
  return photo.thumb || photo.full || '';
}

function GallerySection({ config, photos, onChange }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const selectedPhotos = config.photos || photos || [];
  const layout = config.layout || 'B';

  const removePhoto = (idx) => {
    const next = [...selectedPhotos];
    next.splice(idx, 1);
    onChange({ ...config, photos: next });
  };

  const handleAddPhotos = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      const base = legacy.server_by_hostname('aurora', 'files/sale_photo/');
      const uploaded = await Promise.all(
        files.map(async (f) => {
          const key = await uploadReportImage(f);
          return { key, thumb: base + '380x200_' + key, full: base + key };
        })
      );
      onChange({ ...config, photos: [...selectedPhotos, ...uploaded] });
    } catch (err) {
      console.error('Gallery upload failed:', err);
      alert('이미지 업로드에 실패했습니다.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <SectionHeader
        icon={<ImageIcon />}
        title="사진 업로드"
      />
      <div className={styles.grid}>
        <Field label="매물 사진" span={12}>
          <div className={styles.photoSummary}>
            <span>
              <span className={styles.photoSummaryCount}>{selectedPhotos.length}</span>장 등록됨 · 사진은 최대 24장까지 넣을 수 있습니다.
            </span>
          </div>
          <div className={styles.photoGrid}>
            {selectedPhotos.map((photo, i) => (
              <PhotoCard
                key={i}
                url={getThumb(photo)}
                order={i + 1}
                isCover={false}
                onRemove={() => removePhoto(i)}
              />
            ))}
            <label className={styles.photoAdd} onClick={() => !uploading && fileRef.current?.click()}>
              <PlusIcon />
              <span className={styles.photoAddLabel}>{uploading ? '업로드 중...' : '사진 추가'}</span>
              <input
                ref={fileRef}
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={handleAddPhotos}
              />
            </label>
          </div>
        </Field>

        <Field label="갤러리 레이아웃" span={12}>
          <LayoutCard
            layouts={LAYOUTS.map((l) => ({
              ...l,
              disabled: selectedPhotos.length < l.minPhotos,
            }))}
            value={layout}
            onChange={(key) => onChange({ ...config, layout: key })}
          />
        </Field>
      </div>
    </>
  );
}

export default GallerySection;
